import React from "react";
import Page from "components/Page";
import { Props } from "./RoleCustomTypes";
import { lazyWithRetry } from "helpers/lazyWithRetry";

const RoleCustomTypes = lazyWithRetry(() => import("./RoleCustomTypes"));

export default (props: Props) => (
  <Page>
    <RoleCustomTypes {...props} />
  </Page>
);
